import React, { Component } from "react";

import classnames from "classnames";

import{FormattedDate} from "react-intl";

import ReCAPTCHA from "react-google-recaptcha";

import { pushDatatoServer } from "../../utils/RequestsHelper";

import { Link } from 'react-router-dom';

const recaptchaRef = React.createRef();



const availableParticipantsStyle = {
  float: 'right'
};

const textStyle = {
  lineHeight: '30px'
};


class ModalInscricao extends Component {
  constructor(props) {
    super(props);
    

    this.state = {
      modalIsOpen: false,
      numeroPessoas: "",
      numeroAdultos: "",
      numeroCriancas: "",
      name: "",
      email: "",
      telefone: "",
      availableParticipants: undefined,
      isReservaFeita: false
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.validateData = this.validateData.bind(this);
    this.onChangeNumero = this.onChangeNumero.bind(this);

  }

  onChangeNumero(event){
    const re = /^[0-9\b]+$/;

    // if value is not blank, then test the regex

    if (event.target.value === '' || re.test(event.target.value)) {
       this.setState({[event.target.name]: event.target.value})
    }
}

  componentWillReceiveProps(nextProps) {
    console.log("will receive props -> ", nextProps);
    const available = parseInt(nextProps.noticia.maxParticipants) - parseInt(nextProps.noticia.currentParticipants);
    this.setState({availableParticipants: available});
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    this.props.closeModal();
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  render() {
    return (
      <div
        className="modal-content"
      >

        
          <h4 className="titulo-modal-inscricao">Inscrição </h4>
          <p className="info-inscricao">Evento <span>{this.props.noticia.title}</span></p>
          <p className="info-inscricao">Preço por adulto <span>{this.props.noticia.price}</span>&nbsp;€</p>
          <p className="info-inscricao">Preço por criança <span>{this.props.noticia.childPrice}</span>&nbsp;€</p>

          <div className="row">
          <div className="col-6">
          <p className="info-inscricao">Data&nbsp; 
            <span>
              <FormattedDate
                value={this.props.noticia.startDate}
                year='numeric'
                month='long'
                day='2-digit'
              />
            </span>
          </p>
          </div>

          <div className="col-6">
            <p style={availableParticipantsStyle} className="info-inscricao">Vagas disponíveis: <span>{parseInt(this.props.noticia.maxParticipants) - parseInt(this.props.noticia.currentParticipants)}</span></p>
          </div>
          </div>

          

        <div className="div-divider-inscricao"></div>
        {this.state.isReservaFeita === false ? 
          <React.Fragment>
        <div className="row">
          <div className="col-12">
            <p className="labels">Nome{this.renderMandatoryMessage("nameMissing")}</p>
            <input
              className={classnames(
                "input-form",
                "input-inscricao",
                this.state.isNameValid === false ? "bad-form" : ""
              )}
              type="text"
              name="name"
              value={this.state.name}
              placeholder="Nome completo"
              onChange={this.handleChange}
            />
          </div>

          <div className="col-12 col-md-6">
            <p className="labels">Número de adultos {this.renderMandatoryMessage("numeroAdultosMissing")} {this.renderNumeroPessoasInvalid("numeroAdultosInvalid")}</p>
            <input
              className={classnames(
                "input-form",
                "input-inscricao",
                this.state.isNumeroAdultosValid === false ? "bad-form" : ""
              )}
              type="text"
              name="numeroAdultos"
              value={this.state.numeroAdultos}
              placeholder="Numéro de adultos a inscrever"
              onChange={this.onChangeNumero}
            />
          </div>

          <div className="col-12 col-md-6">
            <p className="labels">Número de crianças (6 a 12 anos) {this.renderMandatoryMessage("numeroCriancasMissing")} {this.renderNumeroPessoasInvalid("numeroCriancasInvalid")}</p>
            <input
              className={classnames(
                "input-form",
                "input-inscricao",
                this.state.isNumeroCriancasValid === false ? "bad-form" : ""
              )}
              type="text"
              name="numeroCriancas"
              value={this.state.numeroCriancas}
              placeholder="Numéro de crianças a inscrever"
              onChange={this.onChangeNumero}
            />
          </div>

          <div className="col-12 col-md-6">
            <p className="labels">Email{this.renderMandatoryMessage("emailMissing")} {this.renderEmailInvalid("emailInvalid")}</p>
            <input
              className={classnames(
                "input-form",
                "input-inscricao",
                this.state.isEmailValid === false ? "bad-form" : ""
              )}
              type="text"
              name="email"
              value={this.state.email}
              placeholder="O seu e-mail"
              onChange={this.handleChange}
            />
          </div>

          <div className="col-12 col-md-6">
            <p className="labels">Telefone{this.renderMandatoryMessage("telefoneMissing")} {this.renderTelefoneInvalid("telefoneInvalid")}</p>
            <input
              className={classnames(
                "input-form",
                "input-inscricao",
                this.state.isTelefoneValid === false ? "bad-form" : ""
              )}
              type="text"
              name="telefone"
              value={this.state.telefone}
              placeholder="Nº Telefone"
              onChange={this.onChangeNumero}
            />
          </div>

          <div className="col-4">
            <p className="labels">Total a pagar</p>
            <p>{this.state.numeroAdultos !== "" || this.state.numeroCriancas !== "" ? (parseInt(this.state.numeroAdultos) || 0) * this.props.noticia.price + (parseInt(this.state.numeroCriancas) || 0) * this.props.noticia.childPrice + " €" : "0€"}</p>
          </div>

          <div className="col-12">
  
            <ReCAPTCHA
              ref={recaptchaRef}
              size="invisible"
              sitekey="6LejQrUUAAAAAHrlOlpV6xHP-yMOFkQX65iTnoM5"
            />
 
          </div>

          <div className="col-12">
            <p className="confirm-terms">Ao confirmar a inscrição, declaro que li e aceito os <Link className="link-terms" to="/termos_e_condicoes">termos e condições</Link>.</p>
          </div>
        </div>
        
        <div className="botoes-inscricao">
          <button
            onClick={this.submitForm}
            className="backoffice-btn btn btn-outline-success"
          >
            Confirmar Inscrição
          </button>

          <button
            className="backoffice-btn btn btn-outline-danger"
            onClick={this.closeModal}
          >
            Cancelar
          </button>
        </div>
        </React.Fragment>

        :
        
        <React.Fragment>

          <p className="titulo-modal-inscricao">Reserva efetuada com sucesso.</p>
          <p style={ textStyle }>Obrigado pela sua reserva no evento {this.props.noticia.title}.<br></br><br></br>
          Irá receber um email com a notificação da reserva, bem como o procedimento para realizar o pagamento. Caso não receba, verifique a caixa de spam do seu email.<br></br>
          Caso tenha alguma dúvida, pode contactar-nos através do número 238 314 619 ou através do email fsabugueiro2017@gmail.com.<br></br><br></br>
          Com os melhores cumprimentos,<br></br>
          Junta de freguesia do Sabugueiro </p>

          <button
            className="backoffice-btn btn btn-outline-danger"
            onClick={this.closeModal}
          >
            Fechar
          </button>


          
        </React.Fragment>
        
        }
      </div>
    );
  }


  renderMandatoryMessage = (field) =>{
    if(this.state[field] === true){
        return(
            <span className="alert-danger ml-6">Campo obrigatório</span>
        )
    }
  }

  renderEmailInvalid = (field, message) =>{
    if(this.state[field] === true){
        return(
            <span className="alert-danger ml-6">Email submetido inválido</span>
        )
    }
  }

  renderNumeroPessoasInvalid = (field) =>{
    if(this.state[field] === true){
        return(
            <span className="alert-danger ml-6">Vagas insuficientes</span>
        )
    }
  }

  renderTelefoneInvalid = (field) =>{
    if(this.state[field] === true){
        return(
            <span className="alert-danger ml-6">Inválido</span>
        )
    }
  }



  calculateAvailableParticipants = () => {
    const available = parseInt(this.props.noticia.maxParticipants) - parseInt(this.props.noticia.currentParticipants);
    return available;
  }

  submitForm = () => {

    recaptchaRef.current.execute();
    
    let isFormValid = this.validateData();
  
    if (isFormValid){

      this.setState({isLoading: true});

      let data = {
        name: this.state.name,
        numeroAdultos: this.state.numeroAdultos,
        numeroCriancas: this.state.numeroCriancas,
        email: this.state.email,
        telefone: this.state.telefone,
        _id: this.props.noticia._id,
      }

      this.saveInscricao(data);
    
      console.log("ia guardar inscricao", data);

    } else{
      
    }
    
  }

  saveInscricao = async data => {
    let res = {};
    try {
      
      res = await pushDatatoServer("/api/inscricoes", data, "post");
      
      if (
        res.response !== undefined &&
        res.response.data !== undefined &&
        res.response.data.errors !== undefined &&
        res.response.data.errors.length !== 0
      ) {
        
        //const missingFields = res.response.data["errors"];

      } else {
        this.setState({isReservaFeita: true});
      }
    } catch (err) {
      
      console.log(err);
    }
  };

  validateData = () => {   
    let isFormValid = true;

    if (!this.validateField("name", "isNameValid")){
        isFormValid = false;
    };
    

    if (!this.validateEmail("email", "isEmailValid")){
      isFormValid = false;
    } 
    
    if(!this.validateField("numeroAdultos", "isNumeroAdultosValid")) {
      isFormValid = false;
    }

    if(!this.validateField("numeroCriancas", "isNumeroCriancasValid")) {
      isFormValid = false;
    }

    if(!this.validateNumeroInscritos()) {
      isFormValid = false;
    }    

    if(!this.validateField("telefone", "isTelefoneValid")){
      isFormValid = false;
      this.setState({"telefoneInvalid":false});
    } else{
      
      let isTelefoneValid = true;

      if(!this.validateTelefone(this.state.telefone)){
        isTelefoneValid = false;
        this.setState({"telefoneInvalid":true});
        this.setState({"isTelefoneValid": false});
      } else{
        isTelefoneValid = true;
        this.setState({"telefoneInvalid":false});
        this.setState({"isTelefoneValid": true});
      }

      if(!isTelefoneValid){
        isFormValid = false;
      }

    }

    return isFormValid;
  }

  validateField = (field, isValidValue ) => {
    let newState = {};
    let isValid = true;
    let missingString = field+"Missing";

    if (this.state[field] === "" || this.state[field] === undefined || this.state[field].length===0){
        this.setState({[missingString]:true});
        isValid=false;
    } else{
        this.setState({[missingString]:''});
    }

    newState[isValidValue] = isValid;
    this.setState(newState);
    return isValid;
  }

  validateEmailRegex(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validateTelefone(phoneNumber){
    return (/^[0-9]{9}$/.test(phoneNumber));
  }

  validateEmail = (field, isValidValue) => {
      
    let newState = {};
    let isValid = true;
    let missingString = field+"Missing";

    if (this.state[field] === "" || this.state[field] === undefined || this.state[field].length===0){
      this.setState({[missingString]:true});
      this.setState({"emailInvalid":false});
      isValid=false;
    } else{
        this.setState({[missingString]:''});
    }

    if(isValid){
      if(!this.validateEmailRegex(this.state[field])){
        
        isValid = false;
        this.setState({"emailInvalid":true});
      } else{
        
        isValid = true;
        this.setState({"emailInvalid":false});
      }
    }
    
    newState[isValidValue] = isValid;
    this.setState(newState);
    
    return isValid;

  }

  validateNumeroPessoas = (field, isValidValue) => {
    
    let newState = {};
    let isValid = true;
    let missingString = field+"Missing";
    let fieldInvalid = field+"Invalid";

    if (this.state[field] === "" || this.state[field] === undefined || this.state[field].length===0){
      this.setState({[missingString]:true});
      this.setState({[fieldInvalid]:false});

      isValid=false;
    } else{
        this.setState({[missingString]:''});
    }
    
    newState[isValidValue] = isValid;
    this.setState(newState);
    
    return isValid;

  }

  validateNumeroInscritos = () => {
    let isValid = true;

    console.log("numero inscritos -> ", this.state.numeroAdultos + this.state.numeroCriancas);
    console.log("numero vagas -> ", parseInt(this.props.noticia.maxParticipants) - parseInt(this.props.noticia.currentParticipants));

    const availableParticipants = parseInt(this.props.noticia.maxParticipants) - parseInt(this.props.noticia.currentParticipants)

    if(this.state.numeroAdultos + this.state.numeroCriancas > availableParticipants){
      isValid = false;
      this.setState({"numeroAdultosInvalid":true});
      this.setState({"numeroCriancasInvalid":true});
    } else{
      this.setState({"numeroAdultosInvalid":false});
      this.setState({"numeroCriancasInvalid":false});
    }

    return isValid;
  }
}

export default ModalInscricao;
